import { render, staticRenderFns } from "./mygoodsTab.vue?vue&type=template&id=357c145d&"
import script from "./mygoodsTab.vue?vue&type=script&lang=js&"
export * from "./mygoodsTab.vue?vue&type=script&lang=js&"
import style0 from "./mygoodsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports